export class NexusFormResultModel
{
  public success_message: string;
  public error_message: string;
  public validations:Array<ValidationModel>;

  public Reset(clear_validations: boolean = true){
    this.success_message = null;
    this.error_message = null;
    
    if (clear_validations) {
      this.ClearValidations();
    }
  }

  public Incomplete() {
    this.success_message = null;
    this.error_message = "Please complete all required fields.";
  }

  public Success(message: string = '') {
    this.success_message = message;
    if(!this.success_message)
    {
      this.success_message = "Form Successfully Submitted!";
    }
    this.error_message = null;
  }

  public Error(message: string)
  {
    this.success_message = null;
    this.error_message = message;
  }

  public Validation(model:Array<ValidationModel>)
  {
    this.validations = model;
  }

  public ClearValidations() {
    this.validations = null;
  }
}

export class ValidationModel
{
   public field:string;
   public display_name:string;
   public value:string;
   public message:string;
}